export default (url, callback, data) => {
  try {
    let x = new(window.XMLHttpRequest || ActiveXObject)('MSXML2.XMLHTTP.3.0')
    x.open(data ? 'POST' : 'GET', url, 1)
    //Don't set custom headers to avoid CORS pre-flight request
    x.onreadystatechange = () => x.readyState > 3 && callback && callback(x.responseText, x)
    x.send(data)
  } catch (e) {
    window.console && console.log(e)
  }
}

export function asyncAjax (url, data) {
  return new Promise((resolve, reject) => {
    try {
      let x = new(window.XMLHttpRequest || ActiveXObject)('MSXML2.XMLHTTP.3.0')
      x.open(data ? 'POST' : 'GET', url, 1)
      //Don't set custom headers to avoid CORS pre-flight request
      x.onreadystatechange = () => x.readyState > 3 && resolve && resolve(x)
      x.send(data)
    } catch (e) {
      reject(e)
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/ajax.js